export const phoneMask = process.env.VUE_APP_PHONE_MASK || '+595 900 ### ####';
